<template>
    <div>
        <div class="container-fluid">
            <div class="llp-container-section heightcontainer ">
                <top-header id="height2"></top-header>
                <main-menu id="height3"></main-menu>
                <div class="modal-backdrop">
                    <div class="card col-lg-10 col-md-8 mt-md-4 col-11 p-0">
                        <div class="postmodalcontent">
                            <div class="modal-header borderbottom p-4">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <nav class="navbar navbar-expand-lg bg-info text-white">
                                    <span>
                                        <b>Edit/Update Sales & Property Tax </b>
                                    </span>
                                </nav>
                                <div class=" container-fluid overflow-auto pb-4 menu-margin-top">
                                    <!-- Start the code for this screen here -->
                                    <div class="llp-container-section">

                                        <div class="container-fluid ">

                                            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">

                                                <div
                                                    class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                                                    <label id="zipcodelabel"
                                                        class="col-form-label col-form-label-sm required">Zip Code</label>
                                                </div>
                                                <div
                                                    class="col-12 col-md-12 justify-content-end align-items-center  mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                                                    <input @keypress="isNumber($event)" minlength="5" maxlength="6"
                                                        type="text" v-validate="'required'" name="Zipcode"
                                                        data-vv-as="Zipcode" class="form-control input-sm"
                                                        v-model="editForm.zipcode" placeholder="Enter Zipcode">
                                                    <div v-if="errors.has('Zipcode')" class="alert-danger"> {{
                                                        errors.first('Zipcode') }} </div>
                                                </div>
                                                <div
                                                    class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                                                    <label id="citylabel"
                                                        class="col-form-label col-form-label-sm required">City</label>
                                                </div>
                                                <div
                                                    class="col-12 col-md-12 justify-content-end align-items-center  mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                                                    <input id="city" placeholder="Enter City" class="form-control input-sm"
                                                        v-model.trim="editForm.city" v-validate="'required'"
                                                        data-vv-name="City" maxlength="50"
                                                        onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || event.charCode = 32 || event.charCode = 188 || event.charCode = 190" />
                                                    <div v-if="errors.has('City')" class="alert-danger"> {{
                                                        errors.first('City') }} </div>
                                                </div>
                                                <div
                                                    class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                                                    <label id="statesddlabel"
                                                        class="col-form-label col-form-label-sm required">State</label>
                                                </div>
                                                <div
                                                    class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">

                                                    <!-- <multiselect style="width:100%; color: #777;" v-validate="'required'"
                                                        data-vv-name="State" v-model="editForm.state" :options="states"
                                                        placeholder="Select a State..." :value="states.stateN"
                                                        label="stateN" id="statesdd">
                                                    </multiselect> -->
                                                    <select v-model="editForm.state" class="form-control input-sm">
                                                        <option v-for="option in states" :key="option.stateAlphaC"
                                                            :value="option.stateAlphaC">{{ option.stateN }}</option>
                                                    </select>
                                                    <div v-if="errors.has('State')" class="alert-danger"> {{
                                                        errors.first('State') }} </div>
                                                </div>
                                            </div>

                                            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
                                                <div
                                                    class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                                                    <label id="countrylabel"
                                                        class="col-form-label col-form-label-sm">Country</label>
                                                </div>
                                                <div
                                                    class="col-12 col-md-12 justify-content-end align-items-center  mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                                                    <input id="country" placeholder="Enter Country"
                                                        class="form-control input-sm" v-model="editForm.country" />
                                                </div>
                                                <div
                                                    class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                                                    <label id="stateSalesTax"
                                                        class="col-form-label col-form-label-sm required">State Sales
                                                        Tax</label>
                                                </div>
                                                <div
                                                    class="col-12 col-md-12 justify-content-end align-items-center  mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                                                    <input @keypress="isNumber($event)" type="text" v-validate="'required'"
                                                        name="StateTax"
                                                        pattern="(^100(\.0{1,2})?$)|(^([1-9]([0-9])?|0)(\.[0-9]{1,5})?$)"
                                                        data-vv-as="State Sales Tax" class="form-control input-sm"
                                                        v-model="editForm.stateSalesTax"
                                                        placeholder="Enter State Sales Tax">

                                                    <div v-if="errors.has('StateTax')" class="alert-danger"> {{
                                                        errors.first('StateTax') }} </div>
                                                </div>

                                                <div
                                                    class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                                                    <label id="countrytaxlabel"
                                                        class="col-form-label col-form-label-sm required">Country Sales
                                                        Tax</label>
                                                </div>
                                                <div
                                                    class="col-12 col-md-12 justify-content-end align-items-center  mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                                                    <input @keypress="isNumber($event)"
                                                        pattern="(^100(\.0{1,2})?$)|(^([1-9]([0-9])?|0)(\.[0-9]{1,5})?$)"
                                                        type="text" v-validate="'required'" name="countryTax"
                                                        data-vv-as="Country Sales Tax" class="form-control input-sm"
                                                        v-model="editForm.countrySalesTax"
                                                        placeholder="Enter Country Sales Tax">

                                                    <div v-if="errors.has('countryTax')" class="alert-danger"> {{
                                                        errors.first('countryTax') }} </div>
                                                </div>
                                            </div>

                                            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
                                                <div
                                                    class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                                                    <label id="citylabel"
                                                        class="col-form-label col-form-label-sm required">City Sales
                                                        Tax</label>
                                                </div>
                                                <div
                                                    class="col-12 col-md-12 justify-content-end align-items-center  mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                                                    <input @keypress="isNumber($event)"
                                                        pattern="(^100(\.0{1,2})?$)|(^([1-9]([0-9])?|0)(\.[0-9]{1,5})?$)"
                                                        type="text" v-validate="'required'" name="citySalesTax"
                                                        data-vv-as="City Sales Tax" class="form-control input-sm"
                                                        v-model="editForm.citySalesTax" placeholder="Enter City Sales Tax">

                                                    <div v-if="errors.has('citySalesTax')" class="alert-danger"> {{
                                                        errors.first('citySalesTax') }} </div>
                                                </div>

                                                <div
                                                    class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                                                    <label id="locallabel"
                                                        class="col-form-label col-form-label-sm required">Local Sales
                                                        Tax</label>
                                                </div>
                                                <div
                                                    class="col-12 col-md-12 justify-content-end align-items-center  mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                                                    <input @keypress="isNumber($event)"
                                                        pattern="(^100(\.0{1,2})?$)|(^([1-9]([0-9])?|0)(\.[0-9]{1,5})?$)"
                                                        type="text" v-validate="'required'" name="localSalesTax"
                                                        data-vv-as="Local Sales Tax" class="form-control input-sm"
                                                        v-model="editForm.localSalesTax"
                                                        placeholder="Enter Local Sales Tax">

                                                    <div v-if="errors.has('localSalesTax')" class="alert-danger"> {{
                                                        errors.first('localSalesTax') }} </div>
                                                </div>

                                                <div
                                                    class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                                                    <label id="personallabel"
                                                        class="col-form-label col-form-label-sm required">Personal Sales
                                                        Tax</label>
                                                </div>
                                                <div
                                                    class="col-12 col-md-12 justify-content-end align-items-center  mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                                                    <input @keypress="isNumber($event)"
                                                        pattern="(^100(\.0{1,2})?$)|(^([1-9]([0-9])?|0)(\.[0-9]{1,5})?$)"
                                                        type="text" v-validate="'required'" name="personalSalesTax"
                                                        data-vv-as="Personal Sales Tax" class="form-control input-sm"
                                                        v-model="editForm.personalSalesTax"
                                                        placeholder="Enter Personal Sales Tax">

                                                    <div v-if="errors.has('personalSalesTax')" class="alert-danger"> {{
                                                        errors.first('personalSalesTax') }} </div>
                                                </div>
                                            </div>

                                            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
                                                <div
                                                    class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                                                    <label id="citylabel"
                                                        class="col-form-label col-form-label-sm required">Total Sales
                                                        Tax</label>
                                                </div>
                                                <div
                                                    class="col-12 col-md-12 justify-content-end align-items-center  mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                                                    <input @keypress="isNumber($event)"
                                                        pattern="(^100(\.0{1,2})?$)|(^([1-9]([0-9])?|0)(\.[0-9]{1,5})?$)"
                                                        type="text" v-validate="'required'" name="totalSalesTax"
                                                        data-vv-as="Total Sales Tax" class="form-control input-sm"
                                                        v-model="editForm.totalSalesTax"
                                                        placeholder="Enter Total Sales Tax">

                                                    <div v-if="errors.has('totalSalesTax')" class="alert-danger"> {{
                                                        errors.first('totalSalesTax') }} </div>
                                                </div>


                                                <div
                                                    class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                                                    <label id="personallabel"
                                                        class="col-form-label col-form-label-sm required">Effective
                                                        Date</label>
                                                </div>
                                                <div
                                                    class="col-12 col-md-12 justify-content-end align-items-center  mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                                                    <input  type="date" v-model.trim="editForm.effectiveDate"
                                                        v-validate="'required'" name="effectiveDate" class="form-control input-sm" data-vv-as="Effective Date"  placeholder="Enter Effective Date"/>
                                                    

                                                    <div v-if="errors.has('effectiveDate')" class="alert-danger"> {{
                                                        errors.first('effectiveDate') }} </div>
                                                </div>


                                            </div>
                                        </div>

                                        <center class="mb-3">
                                            <button type="button" @click="updateData"
                                                class="btn btn-secondary">Update</button>&nbsp;&nbsp;&nbsp;
                                            <!-- <button type="button" v-if="selectedEmployeeId !== ''" @click="backEmployee"
                                                class="btn btn-secondary">Back</button> -->
                                        </center>
                                        <br />
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

import httpcommon from '../../../js/http-common.js';
import TopHeader from '@/components/TopHeader.vue';
import BottomFooter from '@/components/BottomFooter.vue';
import MainMenu from '@/components/Menu.vue';

export default {
    name: "editSalesTaxTable",
    props: ["editSalesData"],
    components: { MainMenu,
    TopHeader,
    BottomFooter
  },
    data() {
        return {
            states: [],
            editForm: this.salesData()
        }
    },


    mounted() {
        this.myFunction();
        this.menuheight();
        this.getStateList();
    },
    methods: {
        salesData() {
            console.log(this.editSalesData);
            return {
                zipcode: this.editSalesData.zipCode,
                state: this.editSalesData.state,
                country: this.editSalesData.country,
                city: this.editSalesData.city,
                stateSalesTax: this.editSalesData.stateSalesTax,
                countrySalesTax: this.editSalesData.countrySalesTax,
                citySalesTax: this.editSalesData.citySalesTax,
                localSalesTax: this.editSalesData.localReg,
                personalSalesTax: this.editSalesData.personalPropertyTax,
                totalSalesTax: this.editSalesData.totalSalesTax,
                effectiveDate: this.editSalesData.effectiveDate,
            }
        },
        getStateList() {
            httpcommon.get('/statefip/').then(response => {
                this.states = response.data;
                this.salesData();
            }).catch(e => { this.errorslist.push(e) })
        },
        myFunction() {
            var elmnt = document.getElementById('height2')
            var elmnt1 = document.getElementById('height3')
            var txt = elmnt.offsetHeight
            var width = elmnt.offsetWidth
            var txt1 = elmnt1.offsetHeight
            var ht = txt + txt1
            $('#reporting').css('margin-top', txt + txt1 + 3)
        },
        menuheight() {
            var elmnt = document.getElementById('height2')
            var txt = elmnt.offsetHeight
            $('#height3').css('margin-top', txt)
        },
        close() {
            this.$emit('closeEditSalesModal')
        },
        isNumber: function (evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },

        isPercentage(evt) {
            console.log(evt.target.value);

            var x = parseFloat(evt.target.value);
            if (isNaN(x) || x < 0 || x > 100) {
                // value is out of range
                evt.preventDefault();
                return false
            } else {
                return true
            }

        },

        updateData() {

            let updateData = this.editForm;
            console.log(updateData);

            let formvalue = {};
            formvalue = {
                "city": updateData.city,
                "citySalesTax": updateData.citySalesTax,
                "country": updateData.country,
                "countrySalesTax": updateData.countrySalesTax,
                "localReg": updateData.localSalesTax,
                "personalPropertyTax": updateData.personalSalesTax,
                "state": updateData.state,
                "stateSalesTax": updateData.stateSalesTax,
                "totalSalesTax": updateData.totalSalesTax,
                "zipCode": updateData.zipcode,
                "effectiveDate": updateData.effectiveDate,
            }

            this.$validator.validateAll().then(() => {
                if (!this.errors.any()) {
                    httpcommon.post('salesPropertyTax/edit?id=' + this.editSalesData.id, formvalue).then(res => {
                        if (res) {
                            this.close().then(res => {
                                console.log(res);
                            })

                        }
                    })

                }

            })

        }
    }
}
</script>

<style scoped>
.bottom {
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
}

.modal-backdrop {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000 !important;
}

.pageloader {
    width: 7%;
    margin-top: 5%;
    margin-bottom: 5%;
    margin-left: 46%;
}

#introVideo {
    width: 100%;
    background: black;
}

.card {
    padding: -5px !important;
    margin: 0 auto;
}

label input[type="radio"]:checked~span {
    color: #007AFF;
}

.postmodalcontent {
    border: none !important;
}

.btn:focus {
    box-shadow: none;
}

.tagLineReport {
    height: 10px;
    color: #1F1F1F;
    font-size: 10px;
    font-weight: bold;
    letter-spacing: 0;
    font-style: italic;
    opacity: 60%
}

.button-cancel11 {
    border: 1px solid #1f1f1f;
    border-radius: 4px;
    transition: ease-out 0.3s;
    font-size: 14px !important;
    position: relative;
    z-index: 1;
}

.modal-header {
    border: none;
}

.bodymodal11 {
    padding: 0 !important;
    height: 80vh;
    overflow-y: auto;

}

.bodymodal11 {
    background-color: white;
}

.profile-border {
    padding: 2px;
    border: 2px solid #ced4da;
    border-radius: 50%;
}

/*hide scroll bar */
/*.bodymodal11::-webkit-scrollbar {
  display: none;
}*/
/* Hide scrollbar for IE, Edge and Firefox */

/*.bodymodal11 {
  -ms-overflow-style: none;
  scrollbar-width: none;
}*/
.close {
    padding: 1px 7px 5px 7px !important;
    margin-top: -3px !important;
    margin-right: 5px !important;
}

.close:hover {
    background-color: rgba(161, 166, 179, 0.1);
    border-radius: 60%;
    border: 1px solid rgba(161, 166, 179, .5);
}

.loadingBgImg {
    background: transparent url('../../../assets/logout.png') center no-repeat;
    background-size: 30px 30px;
}

@media screen and (max-width : 600px) {
    .card {
        margin-top: 4%;
    }
}

.nav-link {
    display: block;
    padding: 0.5rem 1rem;
    background-color: #17a2b8;
    color: black;
    margin-left: 5px;
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
    color: black;
    background-color: white;
    border-color: #A9A9A9;
    border-bottom: none;
}

.sidebyside {
    float: right;
}

.menu-margin-top {
    margin-top: 15px !important;
}

.wrap-text {
    white-space: nowrap;
}
</style>
